import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { REPAIR_AND_HOLD } from "MODULES/RepairOrders/constants";
import { RESERVE_FOR_SALE } from "MODULES/inventories/constants";
import NoteTooltip from "MODULES/shared/components/NoteTooltip/NoteTooltip";

const StatusNote = ({ lineItem }) => {
  const text = [];

  if (get(lineItem, "inventory.repair_status") === REPAIR_AND_HOLD) {
    text.push("Repair & Hold");
  }

  if (get(lineItem, "inventory.status") === RESERVE_FOR_SALE) {
    text.push("Reserved For Sale");
  }

  if (lineItem.customer_rma_requested) {
    text.push("RMA");
  }
  if (text.length === 0) return null;

  return <NoteTooltip note={text.join(", ")} icon="fa-comment" />;
};

export default StatusNote;

StatusNote.propTypes = {
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/StatusNote.jsx